import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    table: "cardView"
};

const tableViewSlice = createSlice({
    name: "tableView",
    initialState,
    reducers: {
        setTableUse(state, action) {
            state.table = action.payload;
        },

        clearUser: () => initialState,
    },
});

// Export the actions generated by createSlice
export const { setTableUse } = tableViewSlice.actions;

// Export the reducer to be used in the store
export default tableViewSlice.reducer;